//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Electrode",0,"SelectNXObjectList",0],[0,"ElectrodeNameFilter",1,0],[0,"InterSolid",1,0],[0,"MapFaceColor",1,0],[0,"SameParent",1,0],[0,"SaveResultsInPart",1,0],[1,"SelectParentPartOcc",0,"SelectNXObjectList",0],[0,"Tolerance",1,0],[0,"TouchArea",1,0],[1,"TouchAreaTolerance",0,"Expression",0],[0,"TouchBody",1,0],[1,"Workpiece",0,"SelectNXObjectList",0],[0,"WorkpieceNameFilter",1,0]],[],[]];
SPLM.Tooling.ElectrodeCheckingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ElectrodeCheckingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;